import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1
  },

  userAvatar: {
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
    color: theme.palette.mode === 'dark' ? '#000 !important' : undefined,
  },

  cartActive: {
    color: theme.palette.text.primary
  },

  cartBadge: {
    color: theme.palette.primary.contrastText
  },

  userNotifierBadge: {
    fontSize: '9pt',
    border: `2px solid ${theme.palette.background.paper}`,
    padding: '0 4px'
  },

  userNotifierPaper: {},

  userNotifierListItemPrimary: {
    maxWidth: '570px'
  }
}));
